module.exports = __webpack_public_path__ + "img/3.900be0c5.jpg";